import { Link, useLocation } from 'react-router-dom';
import { Icon } from '@/components/foundations';
import type { NavItemConfig } from './nav';

export type NavItemProps = NavItemConfig & { compact?: boolean };

/**
 * Item da navegação lateral. Ativo na rota exata ou em `activeAlso`.
 * Usa `Link` (não `NavLink`): o `NavLink` só põe `aria-current` quando a própria rota casa,
 * e aqui o item também fica ativo em outras rotas (Conexões em /financas/sync).
 */
export function NavItem({ to, label, icon, activeAlso = [], compact = false }: NavItemProps) {
  const { pathname } = useLocation();
  const active = pathname === to || activeAlso.includes(pathname);
  const cls = [active ? 'active' : '', compact ? 'fin' : ''].join(' ').trim() || undefined;
  return (
    <Link to={to} className={cls} aria-current={active ? 'page' : undefined}>
      <Icon name={icon} />
      {label}
    </Link>
  );
}
